// Library Imports
import React, { lazy } from 'react';

// Local Imports
import { ROUTE_NAMES, ROUTE_PATHS } from '@/router/constants';

// Lazy load components for code splitting
const LiveMediaKit = lazy(() => import('@/panels/Creater/MediaKit/LiveMediaKit'));
const PrivacyAndPolicy = lazy(() => import('@/panels/Auth/PrivacyAndPolicy'));
const TermsAndConditions = lazy(() => import('@/panels/Auth/TermsAndConditons'));
const Authentication = lazy(() => import('@/components/MediaKit/Authentication').then(module => ({ default: module.Authentication })));
const Verification = lazy(() => import('@/components/MediaKit/Verification').then(module => ({ default: module.Verification })));
const CollabRating = lazy(() => import('@/components/MediaKit/CollaborationRating'));
const LogoutUser = lazy(() => import('@/panels/Auth/LogoutUser'));
const EmailVerification = lazy(() => import('@/components/EmailVerification').then(module => ({ default: module.EmailVerification })));
const TiktokAuthentication = lazy(() => import('@/components/TiktokAuthentication').then(module => ({ default: module.TiktokAuthentication })));

// Common Routes (accessible without authentication)
export const commonRoutes = [
  {
    path: ROUTE_PATHS.SHAREABLE_MEDIA_KIT,
    moduleName: 'Shareable Media Kit',
    element: <LiveMediaKit />
  },
  {
    path: ROUTE_PATHS.PRIVACY_POLICY,
    moduleName: 'Privacy Policy',
    element: <PrivacyAndPolicy />
  },
  {
    path: ROUTE_PATHS.TERMS_CONDITIONS,
    moduleName: 'Creator Terms and Conditions',
    element: <TermsAndConditions />
  },
  {
    path: ROUTE_PATHS.KIT_VERIFIED,
    moduleName: 'Kit verified',
    element: <Authentication />
  },
  {
    path: ROUTE_PATHS.MAIL_VERIFY,
    moduleName: 'Mail verified',
    element: <Verification />
  },
  {
    path: ROUTE_PATHS.COLLAB_RATING,
    moduleName: 'Collab Rating',
    element: <CollabRating />
  },
  {
    path: ROUTE_PATHS.LOGOUT,
    moduleName: 'Logout',
    element: <LogoutUser />
  },
  {
    path: ROUTE_PATHS.EMAIL_VERIFICATION,
    moduleName: 'verify-email',
    element: <EmailVerification />
  },
  {
    path: ROUTE_PATHS.TIKTOK_AUTH,
    moduleName: ROUTE_NAMES.AUTHENTICATE_SOCIAL,
    element: <TiktokAuthentication />
  },
];

